import shopifyGenericDefaults from '../shopify-generic/config.js';

const ignoreFields = [
  ...shopifyGenericDefaults.Widgets.find((w) => w.name === 'Facets').ignoreFields,
  'category',
];

shopifyGenericDefaults.Widgets.forEach((w) => {
  if (w.type === 'FacetPanel' || w.name === 'FacetDialog') {
    w.ignoreFields = ignoreFields;
  }
});

const baseUpdateCallback = shopifyGenericDefaults.Widgets.find(
  (w) => w.name === 'SearchResult',
)?.updateCallback;

function updateCallback() {
  baseUpdateCallback?.();

  window.theme?.QuickAdd && new window.theme.QuickAdd(document.querySelector('.cm_SearchResult'));
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['SearchBox', 'SearchResult'].includes(w.name)),
    {
      name: 'SearchResult',
      infiniteScrollDisabled: !!window.Convermax.config?.infiniteScrollDisabled,
      updateCallback,
    },
    {
      name: 'SearchBox',
      location: '.cm-search-box',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxTablet',
      type: 'SearchBox',
      location: '.cm-search-box-tablet',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxMobile',
      type: 'SearchBox',
      location: '.cm-search-box-mobile',
      template: 'SearchBox',
    },
  ],
};
